export default __webpack_public_path__ + "static/media/icon-wapp.20fa0e08.svg";